export default __webpack_public_path__ + "static/ibm-logo-07bf513d806aa90bf9fa269c20dab2b8.png";